export const ICON = {
  accepted: 'check-circle-color',
  declined: 'error',
  finished: 'check-circle-color',
};

export const TITLE = {
  accepted: 'You have accepted the job',
  declined: 'You have declined the job',
  finished: 'This job has been signed off as completed',
};

export const SUBTITLE = {
  accepted: '$partner has been notified.',
  declined:
    "$partner have been notified that you don't want the work to go ahead. We appreciate that you've taken the time to review the quote.",
  finished:
    '$partner have marked this job as complete. No further action is required from you.',
};

export const CLASS_NAMES = {
  title:
    'text-14-22-em text-neutral-700 md:text-20-24-em md:text-neutral-900 mb-3  mt-3 md:mb-6 md:mt-4',
  subtitle: 'text-14-22 text-neutral-600',
};

export const SKELETON_PROPS = {
  title: {
    width: 150,
  },
  subtitle: {
    width: '100%',
    count: 2,
  },
};

export const ICON_PROPS = {
  size: 24,
  stroke: 'neutral-700',
};
